import React, { useContext, useEffect, useState } from 'react'
import NotificationListItem from '../commonUIComponents/NotificationListItem'
import { Button, List, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import notificationService from '../../services/notificationService'
import { NotificationContext } from '../contexts/NotificationContext'

const ViewNotificationPage = () => {
  const { setUnreadNotificationCount } = useContext(NotificationContext)
  const { enqueueSnackbar } = useSnackbar()
  const [notifications, setNotifications] = useState()
  const [pagination, setPagination] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [isLastPage, setIsLastPage] = useState(false)
  const [loading, setLoading] = useState(true)

  const fetchNotifications = () => {
    notificationService.fetchNotifications(pagination, pageSize)
      .then(res => {
        if (notifications) {
          setNotifications([...notifications, ...res.notifications])
        } else {
          setNotifications(res.notifications)
        }
        setIsLastPage(res.pagination.isLastPage)
        setUnreadNotificationCount(res.unread)
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchNotifications()
  }, [pagination])

  const paginationHandler = () => {
    setPagination(pagination + 1)
  }

  const deleteNotificationHandler = () => {
    setLoading(true)
    notificationService.fetchNotifications(pagination, pageSize)
      .then(res => {
        setNotifications(res.notifications)
        setIsLastPage(res.pagination.isLastPage)
        setUnreadNotificationCount(res.unread)
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  return (
    <>
      {notifications
        ? (
          <>
            <List>
              {notifications.map(notification => <NotificationListItem key={notification.id} notification={notification} fetchNotifications={fetchNotifications} onDelete={deleteNotificationHandler} />)}
            </List>
            {!isLastPage
              ? <Button onClick={paginationHandler}>Show More</Button>
              : <></>}</>
          )
        : (
          <>
            <Typography>No Notifications</Typography>
          </>
          )
      }
    </>
  )
}

export default ViewNotificationPage
